/**
 * Shared utilities for admin conversation components.
 */

/**
 * Get source badge configuration (label + variant) for a conversation source.
 *
 * @param {string} source - Conversation source ('webapp', 'whatsapp', 'teams')
 * @param {Function} t - i18next translation function
 * @returns {{ label: string, variant: string }}
 */
export function getSourceBadge(source, t) {
  const sourceMap = {
    webapp: { label: t('conversations.sourceWeb'), variant: 'info' },
    whatsapp: { label: t('conversations.sourceWhatsApp'), variant: 'success' },
    teams: { label: t('conversations.sourceTeams'), variant: 'secondary' },
  };
  return sourceMap[source] || { label: source, variant: 'default' };
}
